<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm4>
                <v-text-field
                  name="saleNo"
                  label="Invoice No."
                  type="text"
                  :rules="rules.invoiceNoRules"
                  v-model="queryParams.saleNo"
                ></v-text-field>
              </v-flex>
              <v-flex sm4>
                <v-btn outline color="primary" @click="onSearch">
                  Search
                  <v-icon right>search</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12></v-flex>
        <v-flex xs12>
          <v-card v-if="sale.id">
            <v-layout row wrap class="pa-3">
              <v-flex xs4>
                <div class="text-xs-left">
                  <p class="font-weight-bold">Invoice No.</p>
                  <p class="font-weight-bold">{{sale.saleNo}}</p>
                </div>
              </v-flex>
              <v-flex xs8>
                <div class="text-xs-right">
                  <v-btn color="primary" @click="confirmBox=true">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                  <v-btn color="error" @click="init()">
                    Cancel
                    <v-icon right>cancel</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
            <div class="text-xs-left pa-3">
              <h3 class="font-weight-bold">Sale Items</h3>
            </div>
            <v-layout row wrap class="light--text pa-3" style>
              <v-flex xs1>Code</v-flex>
              <v-flex xs5>Stock Name</v-flex>
              <v-flex xs1>Color</v-flex>
              <v-flex xs1>Price</v-flex>
              <v-flex xs1>Amount</v-flex>
              <v-flex xs1>Qty</v-flex>
              <v-flex xs1>Return Qty</v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              v-for="(saleItem, index) in sale.notFocItems"
              :key="index"
              class="pa-3"
              style="margin-top: -30px"
            >
              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.productCode"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  v-model="saleItem.productName"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.product.color"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.unitPrice"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-text-field
                  :value="saleItem.unitPrice * saleItem.qty"
                  type="number"
                  min="0"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.qty"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs1 v-if="sale.id">
                <v-text-field
                  v-model="saleItem.returnQty"
                  min="0"
                  type="number"
                  :rules="rules.qtyRules"
                  oninput="this.value = Math.abs(this.value)"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <div class="text-xs-left pa-3">
              <h3 class="font-weight-bold">FOC Items</h3>
            </div>

            <v-layout row wrap class="light--text pa-3">
              <v-flex xs1>Code</v-flex>
              <v-flex xs6>Stock Name</v-flex>
              <v-flex xs1>Color</v-flex>
              <v-flex xs1>Qty</v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              v-for="(saleItem, index) in sale.focItems"
              :key="index"
              class="pa-3"
              style="margin-top: -30px"
            >
              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.productCode"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="saleItem.productName"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.product.color"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              
              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.qty"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Message Dialog Box-->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="error" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Message Dialog Box-->
    <!-- Confirm Box -->
    <v-dialog
      v-model="confirmBox"
      max-width="500px"
      @keydown.enter="updateSale()"
      @keydown.esc="open = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>Are you sure to save this sale return?</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="confirmBox=false">Cancel</v-btn>
          <v-btn color="success" large outline @click="updateSale()" :loading="saveLoading">Proceed</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Confirm Box -->
    <div v-if="sale.id" v-show="false" id="printRetailCash" :data="sale">
      <div style="font-size: 11px;font-family: arial,sans-serif;">
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shopName}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shopAddress}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Tel: {{sale.shopPhoneNo}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Invoice #: {{sale.saleNo}}</p>
        </div>
        <div style="text-align:center">
          <p
            style="font-size:11px;margin:0px"
            id="date"
          >{{ sale.createdDateInMilliSeconds | format-ms-custom-date }}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;font-weight:bold;margin:0px">REPRINT</p>
        </div>
        <div v-if="sale.counter" style="float:left;padding-left:11px">
          <p style="font-size:11px;margin:0px" id="counter">Counter: {{sale.counter.name}}</p>
          <p style="font-size:11px;margin:0px" id="casher">Casher: {{sale.createdBy}}</p>
           <p style="font-size:11px;margin:0px" id="casher">Sale: {{sale.salePerson}}</p>
          <p style="font-size:11px;margin:0px" id="customer">Customer: <span v-if="sale.customer">{{sale.customer.name}}</span></p>
        </div>
        <!--<div style="float:right;padding-right:11px">
          <p style="font-size:11px;margin:0px" id="casher">Casher: {{sale.createdBy}}</p>
        </div>-->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%"></th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
                <th style="text-align:right;width:10%">Price</th>
                <th style="text-align:right;width:20%">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.notFocItems" :key="index">
                <td style="text-align:left;width:50%">{{item.product.name}} {{'(' + item.product.color + ')'}}</td>
                <td style="text-align:center;width:10%">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.qty}}</td>
                <td style="text-align:right;width:10%">{{item.unitPrice | numFormat}}</td>
                <td style="text-align:right;width:20%">{{item.qty * item.unitPrice| numFormat}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
          >
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Total Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.totalAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Tax ({{sale.taxType}})</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.taxAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Discount Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
                v-if="sale.discountAmount > 0"
              >{{sale.discountAmount | numFormat}}</td>
              <td style="text-align:right;font-weight:bold;font-size:11px" v-else>0</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Net Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.netAmount | decFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Received</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.netAmount + sale.payChange | numFormat}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Pay Change</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.payChange | decFormat}}</td>
            </tr>
          </table>
        </div>
        <!-- FOC Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="sale.focItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%">FOC Items</th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
                <th style="text-align:right;width:10%">Price</th>
                <th style="text-align:right;width:20%">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.focItems" :key="index">
                <td style="text-align:left;width:50%">{{item.product.name}} {{'(' + item.product.color + ')'}}</td>
                <td style="text-align:center;width:10%">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.qty}}</td>
                <td style="text-align:right;width:10%">{{item.unitPrice | numFormat}}</td>
                <td style="text-align:right;width:20%">{{item.qty * item.unitPrice | numFormat}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Return Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="sale.returnItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left;width:50%">Return Items</th>
                <th style="text-align:center;width:10%">Unit</th>
                <th style="text-align:center;width:10%">Qty</th>
                <th style="text-align:right;width:10%">Price</th>
                <th style="text-align:right;width:20%">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.returnItems" :key="index">
                <td style="text-align:left;width:50%">{{item.product.name}} {{'(' + item.product.color + ')'}}</td>
                <td style="text-align:center;width:10%">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center;width:10%">{{item.returnQty}}</td>
                <td style="text-align:right;width:10%">{{item.unitPrice | numFormat}}</td>
                <td
                  style="text-align:right;width:20%"
                >{{item.returnQty * item.unitPrice | numFormat}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
        </div>
        <div style="height:5px;"></div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Thank You! Please Come Again.</p>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { saleReturnService } from "../../services/sale-return-service";
import { wholeSaleService } from "../../services/whole-sale-service";
import { Sale } from "../../models/model";
import { saleService } from "../../services/sale-service";
import { SaleReturnFormRules } from "../../helpers/validation-rules";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "SaleReturn",

  components: { Loading },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Sale Return",
        disabled: true
      }
    ],
    confirmBox: false,
    saveLoading: false,
    messageDialogBox: false,
    invoiceNoDialogBox: false,
    responseError: "",
    sale: new Sale(),
    saleItems: [],
    totalRows: 0,
    rules: new SaleReturnFormRules(),
    queryParams: {
      saleNo: ""
    },
    isLoading: false
  }),
  watch: {
    pagination: {
      handler() {
        this.getSaleList();
      },
      deep: true
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.sale = new Sale();
      this.queryParams.saleNo = "";
    },

    onSearch() {
      if (this.queryParams.saleNo.trim() == "") {
        this.responseError = "Invoice No. can't be blank.";
        this.messageDialogBox = true;
      } else {
        this.$router.replace({
          name: "sale-return",
          query: this.queryParams
        });
        this.getSaleList();
      }
    },
    getSaleList() {
      this.showListLoading = true;
      saleReturnService
        .getSaleList(this.queryParams)
        .then(res => {
          if (res.data) {
            this.sale = res.data;
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
            this.messageDialogBox = true;
          }
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    updateSale() {
      let total = 0;
      this.sale.notFocItems.forEach(item => {
        item.totalPrice = item.returnQty * item.unitPrice;
        total += item.totalPrice;
      });
      this.sale.totalReturnAmount = total;
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        saleService
          .returnSale(this.sale)
          .then(res => {
            this.sale = res.data;
            this.saveLoading = false;
          })
          .then(() => {
            this.confirmBox = false;
            this.isLoading = true;
            if (this.sale.printType == "RETAIL_CASH") {
              this.printRetailCash();
            } else if (this.sale.printType == "RETAIL_CREDIT") {
              this.printRetailCredit();
            } else if (this.sale.printType == "WHOLESALE") {
              this.printWholeSale();
            }
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },
    printRetailCash() {
      var printContents = document.getElementById("printRetailCash").innerHTML;
      var reprintWindow = window.open("", "MsgWindow", "width=500,height=500");
      reprintWindow.document.write(printContents);
      setTimeout(() => {
        reprintWindow.save();
        reprintWindow.close();
      }, 600);
      this.isLoading = false;
      this.init();
    },
    printRetailCredit() {
      saleService
        .printSaleInvoiceById(this.sale.id)
        .then(res => {
          var blob = res;
          saleService.showWindowDialog(blob, "SaleInvoice-" + this.sale.id);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
          this.init();
        });
    },
    printWholeSale() {
      this.isLoading = true;
      wholeSaleService
        .printInvoiceById(this.sale.id)
        .then(res => {
          var blob = res;
          wholeSaleService.showWindowDialog(
            blob,
            "WholeSaleInvoice-" + this.sale.id
          );
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
          this.init();
        });
    }
  }
};
</script>